<button class="d-none" data-target="#run-receivable-view" data-toggle="modal" id="btn-toggle-run-receivable-view"></button>
<div class="modal fade" id="run-receivable-view" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="reunReceivableView">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div>
                    <h4 class="modal-title">Manually Run Receivables</h4>
                    @if (entry) {
                        <p class="subtitle">
                            Last ran {{entry.completedAt || entry.startedAt | date:'E MMM d, yyyy h:mm:ss a'}}
                            @if (entry.asOf) {
                                for {{entry.asOf | date:'E MMM d, yyyy'}}
                            }
                        </p>
                    }
                </div>
                <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="form">
                    <div class="form-group">
                        <label for="asOf">
                            @if (termsId && (termsId > 0)) {
                                Recompute the receivables for this loan starting on:
                            }
                            @else {
                                Compute Receivables for:
                            }
                        </label>
                        <input type="date" id="asOf" class="form-control form-conbtrol-sm" formControlName="asOf"/>
                        <small id="asOfHelpBlock" class="form-text text-muted">
                            This feature will also check for any applicable late fees during the computation.
                            @if (!termsId) {
                                Only the loans that need to recompute on the given day will be affected. This is limited to to 
                                <abbr title="True Daily Earnings">TDE</abbr> loans and <abbr title="Scheduled Installment Earnings">SIE</abbr> 
                                loans that have a payment due.
                            }
                        </small>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <div class="actions">
                    <button class="btn btn-sm btn-link" data-dismiss="modal"><span class="text-muted">cancel</span></button>
                    <button class="btn btn-sm btn-primary" (click)="recompute($event)">Run</button>
                </div>
            </div>
        </div>
    </div>
</div>

